import React from 'react';
import PropTypes from 'prop-types';

import './ResourceTag.scss';

export default class ResourceTag extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        text: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
    };

    static defaultProps = {};

    render() {
        const { text, href } = this.props;
        return (
            <h4 className="component-Employer-Marketing-ResourceTag">
                <a href={href} className="tag-link">
                    {text}
                </a>
            </h4>
        );
    }
}
